/**
 * Tiny i18n for the design tool.
 *
 * The host page (src/routes/design.ts) injects:
 *   window.__MM_DESIGN_I18N = { '<key>': '<localized>', ... }
 *
 * for the request locale. We look up by key, fall back to the English
 * source the caller passed inline. The dictionary is fully pre-resolved
 * server-side from the same translations cache used by the storefront,
 * so there's no flicker and no runtime translate-batch request.
 */

declare global {
  interface Window {
    __MM_DESIGN_I18N?: Record<string, string>;
    __MM_DESIGN_LOCALE?: string;
  }
}

function dict(): Record<string, string> {
  return typeof window !== 'undefined' ? (window.__MM_DESIGN_I18N || {}) : {};
}

export function t(key: string, fallback: string): string {
  const d = dict();
  return d[key] || fallback;
}

export function getLocale(): string {
  return typeof window !== 'undefined' ? (window.__MM_DESIGN_LOCALE || 'en') : 'en';
}

export function isRtl(): boolean {
  const loc = getLocale();
  return loc === 'ar' || loc === 'he';
}
